import * as S from "./Form.style";
import { FormTitle } from "@/components/atoms/FormTitle";

interface FormProps {
  nav?: boolean;
  text?: React.ReactElement | undefined;
  title?: string;
  backBtn?: React.ReactElement;
  children: React.ReactElement;
  onSubmit?: any;
  submitBtn?: React.ReactElement;
  processBar?: React.ReactElement;
  isFindingAccount?: boolean;
}

export const Form = ({
  nav = false,
  text,
  title,
  backBtn,
  children,
  onSubmit,
  submitBtn,
  processBar,
  isFindingAccount,
}: FormProps) => {
  return (
    <S.Form
      $nav={nav}
      $submitBtn={submitBtn ? true : false}
      onSubmit={onSubmit}
    >
      <S.FormContent>
        {title && (
          <S.FormTitleBox $isFindingAccount={isFindingAccount}>
            {processBar && processBar}
            <FormTitle title={title} text={text} />
          </S.FormTitleBox>
        )}
        <S.FormContentInit>{children}</S.FormContentInit>
      </S.FormContent>

      {submitBtn && (
        <S.FormBtnBox $backBtn={backBtn ? true : false}>
          {backBtn && backBtn}
          {submitBtn}
        </S.FormBtnBox>
      )}
    </S.Form>
  );
};
